// extracted by mini-css-extract-plugin
module.exports = {"icon":"reactThemeToggle_icon__Zl6SV"};